const Logo = ({ alt, src }) => {
    return(
        <img alt={alt} src={src} className="object-contain h-15 mx-auto"></img>
    )
}

export default Logo